"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.CopyPaste = void 0;
var _copyPaste = require("./copyPaste");
exports.PLUGIN_KEY = _copyPaste.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _copyPaste.PLUGIN_PRIORITY;
exports.CopyPaste = _copyPaste.CopyPaste;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/copyPaste/index.js
// module id = 1323
// module chunks = 0